import createVueApp from '@phoenix/createVueApp';
import CrownNavigation from '@maison/components/organisms/CrownNavigation.vue';

const app = createVueApp({}, true);
app.component('CrownNavigation', CrownNavigation);
app.mount('#phoenix-crown-navigation');
